import invalidateCanvasGraph from '@/hooks/canvas/helpers/invalidateCanvasGraph';
import coerceToRecord from '../helpers/coerceToRecord';
import eventMatchesToolNames from '../helpers/eventMatchesToolNames';
import getStringValue from '../helpers/getStringValue';
import type {
    BuildRefetchCanvasOnItemGenerateSubscriptionParams,
    ChatEffectSubscription,
} from '../types';

const CANVAS_ITEM_GENERATE_TOOL_NAMES = [
    'generate_canvas_image_(gemini)',
    'generate_canvas_image_gemini',
    'generate_canvas_image__gemini_',
    'Generate_Canvas_Image__Gemini_',
    'canvases.generateImageGemini',
    'generate_canvas_image_(openai)',
    'generate_canvas_image_openai',
    'generate_canvas_image__openai_',
    'Generate_Canvas_Image__OpenAI_',
    'canvases.generateImageOpenAI',
];

const buildRefetchCanvasOnItemGenerateSubscription = (
    _params: BuildRefetchCanvasOnItemGenerateSubscriptionParams
): ChatEffectSubscription => {
    return {
        id: 'refetch-canvas-on-item-generate',
        routePattern: '/agents/:agentId/canvas/:canvasId',
        eventType: 'TOOL_CALL_RESULT',
        filter: ({ event, matchParams }) => {
            if (
                !eventMatchesToolNames({
                    event,
                    toolNames: CANVAS_ITEM_GENERATE_TOOL_NAMES,
                })
            ) {
                return false;
            }

            const args = coerceToRecord({ value: event.args });
            const canvasIdFromArgs = getStringValue({ value: args.canvasId });

            if (!canvasIdFromArgs) {
                return true;
            }

            return canvasIdFromArgs === matchParams.canvasId;
        },
        action: ({ queryClient, matchParams }) => {
            invalidateCanvasGraph({
                queryClient,
                organizationId: matchParams.agentId,
                canvasId: matchParams.canvasId,
            });
        },
    };
};

export default buildRefetchCanvasOnItemGenerateSubscription;
